module.exports = __webpack_public_path__ + "img/skip_previous.4664bc69.svg";